import { BasePopUpRenderData } from '../../types';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { TreeDetails } from '../../../networkTree/types';

export enum MoveToPopUpErrorCases {
  MULTIPLE_ENTITY_TYPES_SELECTED = 'MULTIPLE_ENTITY_TYPES_SELECTED',
}

export enum MoveToStates {
  NETWORK_ENTITIES_SELECTED = 'NETWORK_ENTITIES_SELECTED',
  COMPANY_ENTITIES_SELECTED = 'COMPANY_ENTITIES_SELECTED',
  TARGETS_ARE_FROM_MSP_COMPANY = 'TARGETS_ARE_FROM_MSP_COMPANY',
  END_USER_CONTEXT_ENABLED = 'ENDUSER_CONTEXT_ENABLED',
  NETWORK_FOLDER_SELECTED = 'NETWORK_FOLDER_SELECTED',
  NETWORK_COMPUTERS_SELECTED = 'NETWORK_COMPUTERS_SELECTED',
  CONTAINER_ENTITIES_SELECTED = 'CONTAINER_ENTITIES_SELECTED',
  ENTITIES_FROM_DELETED_IN_SELECTED_ITEMS = 'ENTITIES_FROM_DELETED_IN_SELECTED_ITEMS',
  UNMANAGED_ENTITIES_SELECTED = 'UNMANAGED_ENTITIES_SELECTED',
  ENTITIES_ALREADY_MOVING_SELECTED = 'ENTITIES_ALREADY_MOVING_SELECTED',
}

export enum MoveToEvents {
  MOVE_ENTITIES_FINISHED = 'moveEntitiesFinished',
  MOVE_COMPANIES_FINISHED = 'moveCompaniesFinished',
}

export interface MoveToPopUpStates {
  [key: string]: boolean;
}

export enum InvalidDestinationReason {
  INVALID_REASON_GENERIC = 'INVALID_REASON_GENERIC',
  ENTITIES_ALREADY_IN_SELECTED_DESTINATION = 'ENTITIES_ALREADY_IN_SELECTED_DESTINATION',
  DESTINATION_IS_CHILD_OF_PARENT = 'DESTINATION_IS_CHILD_OF_PARENT',
  INVALID_DESTINATION_NETWORK_FOLDERS = 'INVALID_DESTINATION_NETWORK_FOLDERS',
  INVALID_DESTINATION_COMPANY_CLASS_ENTITIES = 'INVALID_DESTINATION_COMPANY_CLASS_ENTITIES',
  INVALID_DESTINATION_NETWORK_COMPUTERS = 'INVALID_DESTINATION_NETWORK_COMPUTERS',
  MSP_MOVING_ENTITIES_NOT_ONLY_ENDPOINTS = 'MSP_MOVING_ENTITIES_NOT_ONLY_ENDPOINTS',
  INVALID_DESTINATION_CONTAINER_ENTITIES = 'INVALID_DESTINATION_CONTAINER_ENTITIES',
  NOT_MSP_CONTEXT = 'NOT_MSP_CONTEXT',
  INVALID_DESTINATION_NETWORK_COMPUTERS_MSP = 'INVALID_DESTINATION_NETWORK_COMPUTERS_MSP',
  MOVE_FROM_DELETED_ANOTHER_COMPANY = 'MOVE_FROM_DELETED_ANOTHER_COMPANY',
  UNMANAGED_ENTITIES_SELECTED = 'UNMANAGED_ENTITIES_SELECTED',
  ENTITIES_ALREADY_MOVING_SELECTED = 'ENTITIES_ALREADY_MOVING_SELECTED',
  COMPANIES_IMPORTING_INACCESSIBLE_MDR_CONTACTS = 'COMPANIES_IMPORTING_INACCESSIBLE_MDR_CONTACTS',
}

export interface MoveToPopUpSpecifics extends BasePopUpRenderData {
  states: MoveToPopUpStates;
  uniqueParentIds: Array<string>;
}

export type DestinationData = TreeDetails & { isValidMspCompany: boolean };

export interface MoveCompaniesOrCompanyFoldersRequestPayload {
  protectedEntitiesIds: Array<string>;
  newParentIdOrHash: string;
}

export interface ValidateMovingEndpointsAcrossCompaniesRequestPayload {
  protectedEntityIds: Array<string>;
  destinationProtectedEntityId: string;
}

export interface ValidateMovingEndpointsAcrossCompaniesResponse {
  [protectedEntityId: string]: { errors: Array<string> };
}

export interface MoveComputersAcrossCompaniesTaskSpecifics {
  destinationGroupId: string;
}

export interface BaseMoveEntityRecord extends ProtectedEntity {
  updateAction: number;
}

export interface UpdateCustomGroupsRequestRecord extends BaseMoveEntityRecord {}
export interface MoveComputersRequestRecord extends BaseMoveEntityRecord {}
export interface DeleteComputersRequestRecord extends BaseMoveEntityRecord {}

export interface UpdateCustomGroupsRequestPayload {
  records: Array<UpdateCustomGroupsRequestRecord>;
}

export interface MoveComputersRequestPayload {
  records: Array<MoveComputersRequestRecord>;
}

export interface CheckIfGroupNamesCollideRecord {
  names: Array<string>;
  type: null | number;
}

export interface CheckIfGroupNamesCollideRequestPayload {
  groups: Array<CheckIfGroupNamesCollideRecord>;
  parentId: string;
}

export interface MoveFinishedEventDetail {
  oldRecords: Array<ProtectedEntity>;
  newRecords: Array<ProtectedEntity>;
}
